export const LIMIT_SCORE = {
  aroma: 12,
  appearance: 3,
  flavor: 20,
  mouthfeel: 5,
  overall: 10,
  total: 50,
};
